<template>
  <div class="experience-container">
    <Button
      shape="outline"
      size="small"
      font-size="13"
      color="white"
      text="gray"
      hover="merch"
      :to="$trailingSlash(localePath(merchPath))"
      class="button-exp"
    >
      {{ $t('home.pre-home.buttonsExperience.button') }}
    </Button>
    <Button
      shape="outline"
      size="small"
      font-size="13"
      color="white"
      text="gray"
      hover="design"
      :to="$trailingSlash(localePath(designPath))"
      class="button-exp"
    >
      {{ $t('home.pre-home.buttonsExperience.button2') }}
    </Button>
  </div>
</template>

<script>
import Button from 'UI/Button';

export default {
  components: {
    Button
  },
  props: {
    designPath: {
      type: String,
      required: false,
      default: ''
    },
    merchPath: {
      type: String,
      required: false,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
.button-exp {
  margin: 0px 5px;
}
.experience-container {
  display: flex;
  flex-wrap: wrap;
}
</style>
